import localStyles from './styles.module.scss';
import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {useAppData} from "../../context/Contexts";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import Countdown from "../Countdown";

const Bonus3TitleSection: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [source, setSource] = useLocalStorage("source", "");

    /*useEffect(() => {
        if (source == 'fb1') {
            setCurrentAppData(prevState => {
                return { ...prevState, with_bonus: true }
            })
        }
    }, [source]);

    function onChange() {
        setCurrentAppData(prevState => {
            return { ...prevState, with_bonus: !prevState?.with_bonus }
        })
    }*/

    //console.log('source=', source);

    return (
        <div
            className={`free_bonus ${localStyles.bonus3_title_section} ${window.scs_custom_style ? localStyles.style01 : ''}`}>

            <div className={`${localStyles.title}`}>
                <strong>{`${props.title}`}</strong><span>
                {
                    (window.scs_title_show_timer) ?
                        <Countdown date={new Date(window.scs_title_countdown_timer).getTime()}/> :
                        <>{`${props.subtitle}`}</>
                }

            </span></div>
            {(window.scs_bonus3_title_bottom) ? <div
                className={`${localStyles.bonus3_title_bottom}`}>{`${window.scs_bonus3_title_bottom.replace('{TODAY}', formatDate(new Date())).replace('{BONUS_VALUE}', getBonusValue())}`}</div> : ''}

        </div>
    );
};

const getBonusValue = () => {
    let total = 0;
    if (window.scs_bonus_section_price_1) {
        total += parseFloat(window.scs_bonus_section_price_1.replace('$', ''));
    }
    if (window.scs_bonus_section_price_2) {
        total += parseFloat(window.scs_bonus_section_price_2.replace('$', ''));
    }
    if (window.scs_bonus_section_price_3) {
        total += parseFloat(window.scs_bonus_section_price_3.replace('$', ''));
    }
    return '$' + total.toFixed(2);
}

const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'}) + getDaySuffix(date.getDate());
};

const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th'; // Special case for 11th, 12th, 13th
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};

export default Bonus3TitleSection;